<template>
	<div class="detail-box round">
		<div class="pro">
			<p class="user-name">
				<small class="user-num">{{item.categoryParent_?item.categoryParent_.name:''}} {{item.categoryChild_?" > "+item.categoryChild_.name:''}}></small>
				{{item.lecName}}
			</p>
			<div class="btn-group-box">
				<div class="btn-group text-center clearfix">
					<!-- {{item.applForm}} -->
					<!-- 노출상태 인디케이터 -->
					<p v-if="isOpened" class="text-white m-l-10 m-r-10 m-b-0 pull-left">
						<span style="color:greenyellow">●</span>
						노출중 <span v-if="item.expsrEnable!=0">(강제설정)</span>
					</p>
					<p v-if="!isOpened" class="text-white m-l-10 m-r-10 m-b-0 pull-left">
						<span style="color:red">●</span>
						노출중이 아님 <span v-if="item.expsrEnable!=0">(강제설정)</span>
					</p>
					<br>
					<!-- 노출상태 토글버튼 -->
					<a v-if="!isOpened" class="btn-sm btn-green round" @click="toggleExpose(1)">노출하기(강제설정)</a>
					<a v-if="isOpened" class="btn-sm btn-red round" @click="toggleExpose(2)">노출하지 않기</a>
					<a v-if="item.expsrEnable!=0" class="btn-sm btn-green round" @click="toggleExpose(0)">노출상태 기본</a>
					<br>
					<!-- 부가기능 버튼 -->
					<a
						class="btn-sm round"
						:href="'#/classroom/'+item.lecId+'/curriculum'"
						target="_blank"
					>강의실</a>
					<!-- <a class="btn-sm round" @click="$emit('apply', item, item.lecId)">수강신청 수기등록</a> -->
				</div>
			</div>
			<!--
			<div class="dash-board clearfix">
				<a href="#none" class="board-item m-0">
					신청
					<span>+ 310건</span>
				</a>
				<a href="#none" class="board-item">
					교육완료
					<span>+ 70건</span>
				</a>
			</div>
			-->
		</div>
		<ul class="pro-detail-tab clearfix" ref="proDetailTab">
			<li class="on" data-tab-no="1">
				<a>강의</a>
			</li>
			<li data-tab-no="2">
				<a>강의정보</a>
			</li>
		</ul>
		<div class="pro-detail" v-bind:class="{on:activatedTab==1}">
			<p class="pro-detail-con" v-if="item.applStartDate || item.applEndDate">
				신청기간
				<small>{{item.applStartDate?item.applStartDate:'미정'}} ~ {{item.applEndDate?item.applEndDate:'계속'}}</small>
			</p>
			<p class="pro-detail-con">
				교육기간
				<small>
					<span class="inline" v-if="item.eduPeriodType!='일정 선택'">{{item.lecEduDateList[0].eduStartDate}} ~ {{item.lecEduDateList[item.lecEduDateList.length-1].eduEndDate?item.lecEduDateList[item.lecEduDateList.length-1].eduEndDate:'계속'}}</span>
					<span class="inline" v-if="item.eduPeriodType=='일정 선택'">{{item.lecEduDateList[0].eduStartDate}} ~ {{item.lecEduDateList[item.lecEduDateList.length-1].eduStartDate}}</span>
				</small>
			</p>
			<p class="pro-detail-con">
				등록일
				<small>{{item.regDate | parseRegDate}}</small>
			</p>
			<p class="pro-detail-con">
				담당자
				<small>{{item.inCharge.mberName}} {{item.inCharge ? (item.inCharge.phoneNum) : ""}}</small>
			</p>
		</div>
		<div class="pro-detail" v-bind:class="{on:activatedTab==2}">
			<p class="pro-detail-con">
				교육대상
				<small>{{item.lesTargetType}} {{item.lesTargetWork? (item.lesTargetWork) : ""}}</small>
			</p>
			<p class="pro-detail-con">
				정원
				<small>{{item.lecEduDateList[0].eduFixedNum && item.lecEduDateList[0].eduFixedNum + " (신청)건" || "없음"}}</small>
			</p>
			<p class="pro-detail-con" v-if="item.finishEnable">
				수료처리
				<small>{{item.autoFinishEnable?"자동수료":"수동수료"}}</small>
			</p>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import server from "../statics/server.js";
import fnAdjustLiWidth from '../mixins/fnAdjustLiWidth';
import moment from "moment";

export default {
	name: "CtrlClassSummary",
	mixins: [fnAdjustLiWidth],
	props: {
		item: Object
	},
	data: function() {
		return {
			activatedTab: 1, // 활성화된 탭 번호. 디폴트는 첫번째 탭이 활성화된 상태.
		};
	},
	methods: {
		toggleExpose: function(value) {
			axios.patch(server.addr()+server.api.LECTURE+"/"+this.item.lecId, {
				expsrEnable: value
			}).then(() => {
				this.$emit("reload", this.item.lecId);
			});
		}
	},

	computed: {
		isOpened: function() {
			// EXPSR_ENABLE필드가 0이면 신청기간에 따라 판단하고, 1이면 무조건 오픈, 2이면 무조건 클로즈
			if(this.item.expsrEnable==0) {
				// 신청시작일이 없는 경우 이 강좌는 노출상태가 아님
				if(!this.item.applStartDate) return false;
				// 신청시작일이 있고, 신청종료일이 없으면
				else if(this.item.applStartDate && !this.item.applEndDate) {
					// 오늘이 신청시작일 이후인 경우 이 강좌는 노출상태임
					if(moment(this.item.applStartDate).unix() < moment().unix()) return true;
					else return false;
				}
				// 신청시작일과 신청종료일이 있으면
				else if(this.item.applStartDate && this.item.applEndDate) {
					// 오늘이 신청시작일 이후이고 신청종료일 이전인 경우 이 강좌는 노출상태임
					if(moment(this.item.applStartDate).unix() < moment().unix() && moment(this.item.applEndDate).unix() > moment().unix()) return true;
					else return false;
				}
				return true;
			} else if(this.item.expsrEnable==1) {
				return true;
			} else if(this.item.expsrEnable==2) {
				return false;
			}
			return true;
		},
		isRunning: function() {
			// LEC_PERIOD_TYPE에 따라서 교육기간 범위 확정
			// ...
			return true;
		}
	},
	filters: {
		parseRegDate(date) {
			return moment(date).format("YYYY-MM-DD");
		}
	}
}
</script>

<style>

</style>